var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3335 22.7145C30.5504 23.0235 29.6557 23.2486 28.702 23.3767C27.7483 23.5048 26.7547 23.5333 25.7794 23.4605C22.8172 23.1545 22.0767 21.7199 19.2626 21.5478C18.227 21.5162 17.1909 21.6045 16.2299 21.8064C15.2689 22.0083 14.4075 22.3186 13.7085 22.7145",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3634 13.342C15.5394 12.4184 16.3469 11.7501 17.2872 11.7501H27.8978C28.7722 11.7501 29.5406 12.3297 29.7808 13.1705L31.8726 20.4919C33.5652 26.4157 29.1172 32.3126 22.9562 32.3126V32.3126C17.1391 32.3126 12.7584 27.0187 13.8468 21.3043L15.3634 13.342Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 33.2915L23.5 39.1665",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.1561,
    y: 39.6561,
    width: 14.6875,
    height: 0.979167,
    rx: 0.489583,
    stroke: "#1C1C1C",
    strokeWidth: 0.979167
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4585 22.521V16.7767V10.0533V10.0533C25.4585 8.82734 26.4523 7.8335 27.6783 7.8335H31.3335H33.2918",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.59993877e1b18fa708db50a543e791db.svg";
export { ForwardRef as ReactComponent };